import { memo, useRef } from 'react';
import Markdown from '@/components/markdown';
import ActionBar, { IActionBarRef } from '../../action-bar';
import { IAi } from '../index';
import { feedback_sumbit } from '@/apis/qa';
import { TFeedbackType } from '@/types';
import { getQaStore } from '@/store/qa';
import { toastInQa } from '@/utils/qa';
import classNames from 'classnames';
import './index.scss';

const AiReply = ({ recordId, content, feedbackType, isFeedbackEvaluation, permanentActionBar }: IAi) => {
    const hoverToolRef = useRef<IActionBarRef>();

    const handleThumbOrTread = async (feedbackType: TFeedbackType) => {
        const { qaConfig, updateQaRecords } = getQaStore()!;
        updateQaRecords(oldRecords =>
            oldRecords.map(item => {
                if (item.recordId !== recordId) return item;
                return { ...item, feedbackType };
            })
        );
        feedback_sumbit({ lucaAskChatId: qaConfig.lucaAskChatId!, lucaAskRecordId: recordId, feedbackType });
    };

    const handleFeedback = async (params: { labels: number[]; content: string }) => {
        toastInQa('反馈成功，感谢您的支持', 'success');
        const { qaConfig, updateQaRecords } = getQaStore()!;
        updateQaRecords(oldRecords =>
            oldRecords.map(item => {
                if (item.recordId !== recordId) return item;
                return { ...item, isFeedbackEvaluation: true };
            })
        );
        feedback_sumbit({ lucaAskChatId: qaConfig.lucaAskChatId!, lucaAskRecordId: recordId, ...params });
    };

    return (
        <div className={classNames('ai-reply-container', permanentActionBar && 'ai-reply-container--add-padding-bottom')}>
            <div className="ai-reply" onMouseEnter={() => hoverToolRef.current?.show()} onMouseLeave={() => hoverToolRef.current?.hide()}>
                <Markdown imgType="normal" content={content} />
            </div>
            <ActionBar
                ref={hoverToolRef}
                isPermanent={permanentActionBar}
                recordId={recordId}
                content={content}
                feedbackType={feedbackType}
                isFeedbackEvaluation={isFeedbackEvaluation}
                onThumbOrTread={handleThumbOrTread}
                onFeedback={handleFeedback}
            />
        </div>
    );
};

export default memo(AiReply);
